import React, { useEffect, useState } from 'react';
import styles from './About.module.css';

function Showcase() {
  const [aboutBlocks, setAboutBlocks] = useState([]); // State to hold the fetched quotes
  const [lisaBlock, setLisaBlock] = useState('');

  useEffect(() => {
    // Fetch content for showcase services
    fetch(process.env.REACT_APP_WP_SERVER + '/wp-json/wp/v2/home_about')
      .then(response => response.json())
      .then(data => {
        const formattedData = data.reduce((acc, item) => {
          const formattedItem = {
            title: item.title?.rendered || '',
            content: item.content?.rendered || '',
            cta_text: item.cta_text || '',
            cta_url: item.cta_url || ''
          };

          // Check if the slug is 'im-lisa'
          if (item.slug === 'im-lisa') {
            // If slug is 'im-lisa', add to setLisaBlock
            setLisaBlock(formattedItem);
          } else {
            // Otherwise, add to setAboutBlocks
            acc.push(formattedItem);
          }
          return acc;
        }, []);

        // Update state for all other items
        setAboutBlocks(formattedData);
      })
      .catch(error => console.error('Error fetching home about block content:', error));

  }, []); // Empty dependency array ensures this runs only once

  return (
    <main>
      <div id={styles["about_columns"]}>
        <div id={styles["lisa_img"]}>
          <img src={process.env.REACT_APP_WP_SERVER + '/wp-content/uploads/2025/01/woman-with-dog-f.png'} alt='woman with dog' />
        </div>
        <div className={styles["about_block"]}>
            <h3 dangerouslySetInnerHTML={{ __html: lisaBlock.title }}></h3>
            <p dangerouslySetInnerHTML={{ __html: lisaBlock.content }}></p>
            {lisaBlock.cta_text ? 
              <div className={styles['btn']}>
                <button className={styles['block-style']} dangerouslySetInnerHTML={{ __html: lisaBlock.cta_text }} onClick={() => window.open(lisaBlock.cta_url, "_blank")}></button>
              </div>
              : null
            }
          </div>
        {aboutBlocks.map((about) => (
          <div className={styles["about_block"]}>
            <h3 dangerouslySetInnerHTML={{ __html: about.title }}></h3>
            <p dangerouslySetInnerHTML={{ __html: about.content }}></p>
            {about.cta_text ? 
              <div className={styles['btn']}>
                <button className={styles['block-style']} dangerouslySetInnerHTML={{ __html: about.cta_text }} onClick={() => window.open(about.cta_url, "_blank")}></button>
              </div>
              : null
            }
          </div>
        ))}
      </div>
    </main>
  );
}

export default Showcase;
